export function getScreenPermission(screen, permissionName, defaultValue = true) {
  if (!screen || typeof screen !== 'object') return defaultValue;
  return screen[permissionName] ?? defaultValue;
}

export function canEditAramaRecord({ currentUser, aramaUser, isGeneralAuth = false, stYetki = null }) {
  // Genel yetkili ve admin, arayan kişi olmasa da kaydı değiştirebilir.
  if (isGeneralAuth) return true;

  const cu = Number(currentUser || 0);
  const au = Number(aramaUser || 0);
  if (!(cu > 0) || cu !== au) return false;

  // Arayan kişi olsa bile sabit tanımında Yetki = Değiştirebilir değilse değiştiremez.
  return Number(stYetki) === 2;
}

/** null: kısıt yok (yönetici veya data sahibi). Dizi: yalnız bu kullanıcılar satış yapan olabilir. */
export function allowedSatisYapanRefs({ currentUser, dataOwner, isGeneralAuth = false }) {
  if (isGeneralAuth) return null;
  const cu = Number(currentUser || 0);
  const owner = Number(dataOwner || 0);
  if (cu > 0 && owner > 0 && cu === owner) return null;
  const refs = [];
  if (cu > 0) refs.push(cu);
  if (owner > 0 && owner !== cu) refs.push(owner);
  return refs;
}

export function canAssignSatisYapan(ctx, selectedRef, previousRef = null) {
  const allowed = allowedSatisYapanRefs(ctx);
  if (allowed == null) return true;
  const selected = Number(selectedRef || 0);
  if (selected > 0 && allowed.includes(selected)) return true;
  const previous = Number(previousRef || 0);
  return previous > 0 && selected === previous;
}

export function canEditAramaBySabitYetki({ stYetki, isGeneralAuth = false }) {
  if (isGeneralAuth) return true;
  // SABIT.ST_YETKI: 0=Sadece Giriş, 1=Genel Yetkili, 2=Değiştirebilir.
  return Number(stYetki) === 2;
}
